import React from 'react'
import Firebase from './firebase'

const FirebaseContext = React.createContext(null as null|Firebase)

export default FirebaseContext